import { Component, inject, OnInit } from "@angular/core";
import { NxCell } from "qlik";
import { Title } from "@angular/platform-browser";
import { FilterComponent } from "../../felles/components/filter/filter.component";
import { KpitabellComponent } from "../../felles/components/kpitabell/kpitabell.component";
import { KommunefilterComponent } from "../../felles/components/kommunefilter/kommunefilter.component";
import { QlikService } from "../../felles/services/qlik.service";
import { AccordionComponent } from "@husbanken/designsystem-angular-core";
import { AccordionElementComponent, HjelpetekstComponent } from "@husbanken/designsystem-angular-core";
import { GrafComponent } from "../../felles/components/graf/graf.component";

@Component({
  selector: "stat-startlan",
  templateUrl: "./startlan.component.html",
  imports: [FilterComponent, KpitabellComponent, KommunefilterComponent, AccordionComponent, AccordionElementComponent, HjelpetekstComponent, GrafComponent],
})
export class StartlanComponent implements OnInit {
  objectKeys = Object.keys;
  statistikkType = "Utbetaling";
  graferValgt = "soknader";
  valgtFilter: { [key: string]: NxCell[] } = null;
  grafIderForSoknad: string[] = [];
  grafIderForBelop: string[] = [];
  grafIderForGjennomsnitt: string[] = [];
  grafIderForAvslag: string[] = [];
  grafIderForAvslagSaker: string[] = [];
  kpiListeForSoknad: string[] = [];
  kpiListeForUtbetaling: string[] = [];
  kpiListeForAvslag: string[] = [];

  typeTekst = {
    Søknad: {
      soknader: ["Antall søknader", "Viser antall søknader som har søkt om finansiering for en gitt periode (søknadsdato)."],
      gjennomsnitt: ["Gjennomsnitt søkt", "Viser gjennomsnittlig søkt finansiering for de som har et oppgitt et beløp i søknaden. "],
    },
    Utbetaling: {
      soknader: ["Antall saker med startlån", "Viser antall saker som har fått utbetalt startlån for en gitt periode (utbetalingsdato). "],
      belop: ["Utbetalt beløp", "Viser totalt utbetalt beløp for en gitt periode (utbetalingsdato). "],
      gjennomsnitt: ["Gjennomsnitt beløp", "Viser gjennomsnittlig utbetalt beløp for en gitt periode (utbetalingsdato). "],
    },
    Avslag: {
      soknader: ["Antall søknader med avslag", "Viser antall søknader som har fått avslag om finansering for en gitt periode (avslagsdato)."],
      vedtak: [
        "Antall vedtak med avslag",
        "En søknad kan ha flere vedtak. Antall vedtak med avslag er totalt antall vedtak som har fått avslag om finansiering for en gitt periode (avslagsdato).",
      ],
    },
  };

  qlikService = inject(QlikService);
  titleService = inject(Title);

  constructor() {
    this.qlikService.resetFilter();
    this.qlikService.setFylkeFilter();
    this.qlikService.setFilter("VirkemiddelKode", "STARTLÅN", false, true);
    this.qlikService.setFilter("TypeTilstand", "Utbetaling", false, true);
  }

  ngOnInit() {
    this.titleService.setTitle("Statistikk - Startlån - Husbanken");
    this.grafIderForSoknad = ["sts-ant-saker-pr-fylke", "sts-ant-saker", "sts-ant-saker-pr-tiltak", "sts-andel-barnefamilier"];
    this.grafIderForBelop = ["sts-beløp-pr-fylke", "sts-beløp", "sts-beløp-pr-tiltak", "sts-beløp-andel-barnefamilier"];
    this.grafIderForGjennomsnitt = ["sts-gjennomsnitt-beløp-pr-fylke", "sts-gjennomsnitt-beløp", "sts-gjennomsnitt-beløp-pr-tiltak", "sts-gjennomsnitt-beløp-andel-barnefamilier"];
    this.grafIderForAvslag = ["sts-antall-avslag-pr-fylke", "sts-antall-avslag", "sts-avslagsgrunner", "sts-avslag-barnefamilier"];
    this.grafIderForAvslagSaker = ["sts-antall-avslag-sak-pr-fylke", "sts-antall-avslag-sak", "sts-avslagsgrunner-sak", "sts-avslag-barnefamilier-sak"];
    this.kpiListeForSoknad = ["STS Antall saker", "STS Andel barnefamilier", "STS Gjennomsnittlig beløp"];
    this.kpiListeForUtbetaling = [
      "STS Antall saker",
      "STS Andel barnefamilier",
      "STS Beløp startlån",
      "STS Gjennomsnittlig startlån",
      "STS Gjennomsnittlig kjøpesum",
      "STS Andel startlån av kjøpesum",
    ];
    this.kpiListeForAvslag = [
      "STS Antall vedtak totalt sak",
      "STS Antall avslag sak",
      "STS Avslagsprosent sak",
      "STS Antall vedtak totalt",
      "STS Antall avslag",
      "STS Avslagsprosent",
    ];
  }

  public filterTilstand(filter) {
    this.qlikService.setFilter("TypeTilstand", filter, false, true);
    this.statistikkType = filter;
  }

  selectedRadio(event) {
    this.graferValgt = event.target.value;
  }

  filterVisning(event) {
    this.valgtFilter = event;
  }

  hentSelectedRadioLabel(): string {
    if (this.typeTekst[this.statistikkType][this.graferValgt]) {
      return this.typeTekst[this.statistikkType][this.graferValgt][0];
    } else {
      return "Antall avslag";
    }
  }
}
